export function getApplicantAttentionWidgetActionProps({
  isActionDisabled,
  isActionFullPageOnly,
  isPreview,
  primaryAction,
  onClickAction,
}) {
  return primaryAction
    ? {
        isDisabled: isActionDisabled,
        label: primaryAction.label,
        onClick: isPreview && isActionFullPageOnly ? null : onClickAction,
      }
    : null
}
